"use client";

import { useShell } from "./shell-context";

/** Natives Auswahlfeld im Stil des Mockups: zugänglich, per Tastatur und mobil bedienbar. */
export function ProjectSwitcher() {
  const { projects, project, selectProject } = useShell();
  if (!project) return null;

  return (
    <div className="relative">
      <select
        aria-label="Projekt wechseln"
        value={project.id}
        onChange={(event) => selectProject(Number(event.target.value))}
        className="h-11 w-full appearance-none rounded-md border border-nav-line bg-nav-raised pl-3 pr-9 text-sm text-white"
      >
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.domain}
          </option>
        ))}
      </select>
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-nav-text"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </div>
  );
}
